var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{attrs:{"query":"is:unread"}})
}
var staticRenderFns = []

export { render, staticRenderFns }